import React from 'react';
import { connect } from 'react-redux';

import InputLabel from 'xgimi-ui/mui/material/InputLabel';
import FormControl from 'xgimi-ui/mui/material/FormControl';
import Select from 'xgimi-ui/mui/material/Select';

import Paper from 'xgimi-ui/mui/material/Paper';
import { HttpStateLine } from 'state-line';
import StoreComponent, { mapStateToProps } from '../../../../../appComponents/Store';

import s from './.module.scss';
import Api from '../../../../../api';

interface Props {
  // 搜索条件
  filterData: Record<string, any>;
  // 条件搜索
  onFilter: (data: Record<string, any>) => void;
  // 当前用户
  ownerUser: string | undefined;
}

interface State {
  // 问题分类
  allTypeList: Record<string, any>[];
  // 回复状态
  replyStatus: number;
  // 问题分类
  feedbackTypeCode: string;
  // 跟进状态
  processStatus: number;
  // 负责人
  ownerUser: string;
}

/**
 * 条件过滤
 */
class Component extends StoreComponent<Props, State> {
  state: State = {
    allTypeList: [],
    replyStatus: this.props.filterData.replyStatus,
    feedbackTypeCode: this.props.filterData.feedbackTypeCode,
    processStatus: this.props.filterData.processStatus,
    ownerUser: this.props.filterData.ownerUser,
  };

  componentDidMount() {
    this.getAllTypeList();
  }

  /**
   * 获取所有问题分类列表
   */
  private getAllTypeList = async (): Promise<void> => {
    const allTypeList: Record<string, any>[] = [];
    const httpStateLine = await new HttpStateLine(new Api.crmFeedback.GetTypeList()).run().catch(() => null);
    httpStateLine?.result?.data?.forEach((item: Record<string, any>) => {
      item.childTypeList.forEach((list: Record<string, any>) => {
        allTypeList.push({
          label: list.desc,
          value: list.code,
        });
        if (list.childTypeList.length > 0) {
          list.childTypeList.forEach((third: Record<string, any>) => {
            allTypeList.push({
              label: `${list.desc} / ${third.desc}`,
              value: third.code,
            });
          });
        }
      });
    });
    this.setState({ allTypeList });
  };

  /**
   * 获取所有问题分类列表
   */
  private onChange = (): void => {
    this.props.onFilter({
      replyStatus: this.state.replyStatus,
      feedbackTypeCode: this.state.feedbackTypeCode,
      processStatus: this.state.processStatus,
      ownerUser: this.state.ownerUser,
    });
  };

  render(): React.ReactNode {
    return (
      <Paper className={s.filter} >
        <FormControl className={s.filterItem}>
          <InputLabel>回复状态</InputLabel>
          <Select
            native
            label="回复状态"
            value={this.state.replyStatus}
            onChange={(event) => this.setState({ replyStatus: Number(event.target.value) }, this.onChange)}
          >
            <option value={-1}>全部</option>
            <option value={0}>未回复</option>
            <option value={1}>已回复</option>
          </Select>
        </FormControl>
        <FormControl className={s.filterItem}>
          <InputLabel>问题分类</InputLabel>
          <Select
            native
            label="问题分类"
            value={this.state.feedbackTypeCode}
            onChange={(event) => this.setState({ feedbackTypeCode: event.target.value as string }, this.onChange)}
          >
            <option value={'-1'}>全部</option>
            {this.state.allTypeList.map((item: Record<string, any>, index) => (
              <option key={index} value={item.value}>{item.label}</option>))}
          </Select>
        </FormControl>
        <FormControl className={s.filterItem}>
          <InputLabel>跟进状态</InputLabel>
          <Select
            native
            label="跟进状态"
            value={this.state.processStatus}
            onChange={(event) => this.setState({ processStatus: Number(event.target.value) }, this.onChange)}
          >
            <option value={-1}>全部</option>
            <option value={0}>未处理</option>
            <option value={1}>已联系</option>
            <option value={2}>已回复</option>
            <option value={3}>已完结</option>
            <option value={4}>用户未回复</option>
            <option value={5}>已复现</option>
            <option value={6}>未复现</option>
            <option value={-2}>无</option>
          </Select>
        </FormControl>
        <FormControl className={s.filterItem}>
          <InputLabel>负责人</InputLabel>
          <Select
            native
            label="负责人"
            value={this.state.ownerUser}
            onChange={(event) => this.setState({ ownerUser: event.target.value as string }, this.onChange)}
          >
            <option value={'-1'}>全部</option>
            <option value={this.props.ownerUser}>我</option>
          </Select>
        </FormControl>
      </Paper>
    );
  }
}

export default connect(mapStateToProps)(Component);
